import moment from "moment";

export const uniqueId: uniqueIdType = (prefix = "") => `${prefix}${moment().valueOf()}`;

type uniqueIdType = (prefix?: string) => string;
